import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { HelpPanel } from '@/components/layout/HelpPanel';
import { Sidebar } from '@/components/layout/Sidebar';
import { SidebarEdgeToggle } from '@/components/layout/SidebarEdgeToggle';
import { masterAdminNav } from '@/config/navigation';
import { BRAND } from '@/config/brand';
import { env } from '@/config/env';
import { useGlobalHelpShortcut } from '@/hooks/useGlobalHelpShortcut';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { toggleSidebar } from '@/store/appSlice';
import { useWorkspaceTitle } from '@/hooks/useWorkspaceTitle';

export function MasterAdminLayout() {
  const collapsed = useAppSelector((s) => s.app.sidebarCollapsed);
  const dispatch = useAppDispatch();
  useWorkspaceTitle();
  const [helpOpen, setHelpOpen] = useState(false);
  const openHelp = useCallback(() => setHelpOpen(true), []);
  useGlobalHelpShortcut(openHelp);

  return (
    <div className="workspace-shell flex h-screen flex-col bg-slate-50 dark:bg-slate-950">
      <Header moduleLabel="Master Admin" onOpenHelp={openHelp} />
      <div className="relative flex min-h-0 flex-1 overflow-hidden">
      {!collapsed && (
        <button
          type="button"
          className="workspace-sidebar-backdrop lg:hidden"
          aria-label="Close sidebar"
          onClick={() => dispatch(toggleSidebar())}
        />
      )}
      <Sidebar
        items={masterAdminNav}
        collapsed={collapsed}
        onToggle={() => dispatch(toggleSidebar())}
        brand={env.appName || BRAND.name}
        appLabel="Master Admin"
      />
      {collapsed && (
        <SidebarEdgeToggle
          collapsed
          onToggle={() => dispatch(toggleSidebar())}
          variant="mobile"
        />
      )}
      <main className="flex-1 overflow-y-auto p-6">
        <Outlet />
      </main>
      </div>
      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
}
